import { Search } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import ButtonIcon from './ButtonIcon'

const ButtonLoadingSearch = ({
    id,
    onClick,
    disabled,
    isLoading = false
}) => {
    const { t } = useTranslation()

    return (
        <ButtonIcon id={id} disabled={disabled} sx={(theme) => ({ backgroundColor: theme.palette.primary.main })} variant='contained' loading={isLoading} loadingPosition='start' onClick={onClick} startIcon={<Search sx={{ color: 'white' }} />}>
            {t("actions.search")}
        </ButtonIcon>
    )
}

export default ButtonLoadingSearch